import { MenuItem } from '@material-ui/core';
import { BooleanString } from '@utils/TypeHelpers';
import React from 'react';
import { CreateOptionsParams, ISpecializedCombo, useCombo } from './useCombo';

export type BooleanSet = {
    value: string,
    text: string
}

export type IComboBoolean = ISpecializedCombo<BooleanSet>;

export function useComboBoolean (initialValue: BooleanString = "") : IComboBoolean {
    const combo = useCombo<BooleanSet>({
        value: initialValue,

        set: [
            { value: "0", text: "Não" },
            { value: "1", text: "Sim" },
        ]
    });

    const createOptions = React.useCallback((params?: CreateOptionsParams) => {
        return combo.set.map((options, index) => {
            return <MenuItem key={index} value={options.value}>{params?.prefix}{options.text}{params?.sufix}</MenuItem>
        })
    }, [combo.set]);

    const loadOptions = React.useCallback(() => {}, []);

    return React.useMemo(() => ({
        ...combo,
        createOptions,
        loadOptions
    }), [combo, createOptions, loadOptions]);
}